if (!customElements.get('featured-videos')) {
  class FeaturedVideos extends HTMLElement {
    constructor() {
      super();

      this.featuredVideos = this.querySelectorAll('[data-featured-video]');
      this.featuredVideoCardPlayButtons = this.querySelectorAll('[data-featured-video-card-play-button]');

      if (this.featuredVideoCardPlayButtons.length) {
        this.addEventListener('click', this.updateFeaturedVideo.bind(this));
      }

      this.swiperInit();
    }

    updateFeaturedVideo(event) {
      if (!event.target.hasAttribute('data-featured-video-card-play-button')) { return; }

      const buttonIndex = event.target.getAttribute('data-index');

      this.featuredVideos.forEach((video) => {
        const videoIndex = video.getAttribute('data-index');
        const videoIframe = video.querySelector('iframe');
        const videoElement = video.querySelector('video');
        const videoIframeSrc = videoIframe ? videoIframe.getAttribute('data-src') : null;
        const playButton = video.querySelector('[data-video-play-button]');
        const videoWrapper = video.querySelector('[data-video-wrapper]');

        if (videoIndex == buttonIndex) {
          video.classList.remove('d-none');
          playButton.classList.add('d-none');
          videoWrapper.classList.remove('d-none');

          if (videoIframe) {
            videoIframe.setAttribute('src',`${videoIframeSrc}?autoplay=1`);

            setTimeout(() => {
              videoIframe.focus();
            }, 200);
          } else if (videoElement) {
            videoElement.play();

            setTimeout(() => {
              videoElement.focus();
            }, 200);
          }

          const sectionTopPosition = event.target.closest('[data-featured-videos]').offsetTop;
          window.scrollTo(0, sectionTopPosition);
        } else {
          video.classList.add('d-none');

          if (videoIframe) {
            videoIframe.setAttribute('src',`${videoIframeSrc}?autoplay=0`);
          } else if (videoElement) {
            videoElement.pause();
          }
        }
      });
    }

    swiperInit() {
      const carousel = this.querySelector('[data-swiper]');

      if (!carousel) { return; }

      const prevButton = this.querySelector('[data-swiper-prev]');
      const nextButton = this.querySelector('[data-swiper-next]');

      const swiper = new window.Swiper(carousel, {
        spaceBetween: 8,
        centeredSlides: true,
        slidesPerView: 'auto',
        draggable: true,
        threshold: 20,
        loop: true,
        breakpoints: {
          768: {
            centeredSlides: false,
            slidesPerView: 3,
          },
          1025: {
            centeredSlides: false,
            slidesPerView: 4
          }
        },
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton
        }
      });

      return swiper;
    }
  }

  customElements.define('featured-videos', FeaturedVideos);
}